<div class="mb-2">
  <h1 class="main-title">Mis novedades</h1>
</div>

<div class="box mb-6">
  <h2 class="main-subtitle my-4">Seguridad / Calidad / Medio ambiente</h2>
  <button class="button button-success button-sm" (click)="newUpdateRecord('seguridad')">
    Nueva novedad
  </button>
  <app-table
    class="table-news table-switch"
    [columns]="tableSeguridadColumns"
    [data]="flattenedData['seguridad']"
    [tableType]="'seguridad'"
    (checkboxChange)="onCheckboxChange($event.checked, $event.id)"
    (selectAllChange)="onSelectAllChange($event)"
  >
    <ng-template #actionTemplate let-visation>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(visation)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="" />
        </button>
        <button (click)="editUpdateRecord(visation)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="" />
        </button>
        <button (click)="deleteUpdateRecord(visation.id)" title="Eliminar">
          <img src="assets/icons/trashcan-icon.svg" alt="" />
        </button>
      </div>
    </ng-template>
  </app-table>
</div>

<div class="box mb-6">
  <h2 class="main-subtitle my-4">Personal</h2>
  <button class="button button-primary button-sm mb-4" (click)="newUpdateRecord('personal')">
    Nueva novedad
  </button>
  <app-table
    class="table-news table-switch"
    [columns]="tableColumns"
    [data]="flattenedData['personal']"
    [tableType]="'personal'"
    (checkboxChange)="onCheckboxChange($event.checked, $event.id)"
    (selectAllChange)="onSelectAllChange($event)"
  >
    <ng-template #actionTemplate let-visation>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(visation)">
          <img src="assets/icons/eye-icon.svg" alt="" />
        </button>
        <button (click)="editUpdateRecord(visation)" title="Editar">
            <img src="assets/icons/pencil-icon.svg" alt="" />
        </button>
        <button (click)="deleteUpdateRecord(visation.id)" title="Eliminar">
            <img src="assets/icons/trashcan-icon.svg" alt="" />
        </button>
      </div>
    </ng-template>
  </app-table>
</div>